import { Question } from '../Types/Question';
import { QuestionResponse } from '../Types/QuestionResponse';
import { UserAchievement } from '../Types/UserAchievement';
import { UserLootBox } from '../Types/UserLootBox';
import { mapUserAchievement } from './AchievementsApi';
import { getApiInstance } from './Api';
import { mapUserLootBox } from './RewardsApi';

function mapQuestionResponse(questionResponse: any): QuestionResponse {
  return {
    questionId: questionResponse.questionId,
    chosenOptionIndex: questionResponse.chosenOptionIndex,
    answerState: questionResponse.answerState,
    isCompleted: true,
  };
}

export class QuestionResponseApi {
  async fetchQuestionResponses(articleId: string): Promise<QuestionResponse[]> {
    try {
      const result = await getApiInstance().get(
        `/question-responses/${articleId}`,
      );
      console.log('Question responses fetched:', result.data);
      return result.data.map(mapQuestionResponse);
    } catch (error) {
      console.error('Error fetching question responses', error);
      throw error;
    }
  }

  async recordQuestionResponse(
    question: Question,
    response: QuestionResponse,
  ): Promise<{
    questionResponse: QuestionResponse;
    userAchievements: UserAchievement[];
    lootBox: UserLootBox | null;
  }> {
    try {
      const result = await getApiInstance().post(`/question-responses`, {
        questionId: question.id,
        response: question.questionOptions[response.chosenOptionIndex],
        chosenOptionIndex: response.chosenOptionIndex,
      });
      console.log('Question response recorded:', result.data);
      return {
        questionResponse:
          result.data.questionResponse &&
          mapQuestionResponse(result.data.questionResponse),
        userAchievements: result.data.userAchievements?.map(mapUserAchievement),
        lootBox: result.data.lootBox && mapUserLootBox(result.data.lootBox),
      };
    } catch (error) {
      console.error('Error recording question response', error);
      throw error;
    }
  }
}
